import { useMemo } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { DOWNLOADS } from "@/data/landingData";

const DownloadsSection = () => {
  const { copy } = useLanguage();

  const resources = useMemo(
    () =>
      copy.resources.items.map((item) => ({
        ...item,
        url: DOWNLOADS[item.id],
      })),
    [copy.resources.items],
  );

  return (
    <section
      className="section downloads-section"
      id="ressources"
      data-testid="downloads-section"
    >
      <div className="container downloads-container" data-testid="downloads-container">
        <div className="section-header" data-testid="downloads-header">
          <p className="section-kicker" data-testid="downloads-kicker">
            {copy.resources.kicker}
          </p>
          <h2 className="section-title" data-testid="downloads-title">
            {copy.resources.title}
          </h2>
          <p className="section-text downloads-subtitle" data-testid="downloads-subtitle">
            {copy.resources.subtitle}
          </p>
        </div>
        <div className="downloads-grid" data-testid="downloads-grid">
          {resources.map((item, index) => (
            <article className="download-card" key={item.id} data-testid={`download-card-${item.id}`}>
              <div
                className="download-card-header"
                data-testid={`download-card-header-${item.id}`}
              >
                <span className="download-tag" data-testid={`download-tag-${item.id}`}>
                  {copy.resources.formatLabel}
                </span>
                <span className="download-index" data-testid={`download-index-${item.id}`}>
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 data-testid={`download-title-${item.id}`}>{item.title}</h3>
              <p data-testid={`download-description-${item.id}`}>{item.description}</p>
              <div className="download-actions" data-testid={`download-actions-${item.id}`}>
                <a
                  className="secondary-button download-link"
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`download-link-${item.id}`}
                >
                  {item.cta}
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DownloadsSection;
